// Firebase 초기화 및 설정
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { Capacitor } from '@capacitor/core';

// 플랫폼 감지
const platform = Capacitor.getPlatform();

// Firebase 설정 (플랫폼별 분기)
const firebaseConfig = platform === 'web'
  ? {
      // 웹용 설정 (환경 변수)
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    }
  : {
      // Android/iOS용 설정 (google-services.json 값)
      apiKey: "AIzaSyBlQTWJjOFdLOIgt5idHFkkSkrnEWKtZxI",
      authDomain: "plc-error-guide.firebaseapp.com",
      projectId: "plc-error-guide",
      storageBucket: "plc-error-guide.firebasestorage.app",
      messagingSenderId: "981388628573",
      appId: "1:981388628573:android:fda33f6472faa34ab1f3b4",
    };

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firestore 데이터베이스 초기화
export const db = getFirestore(app);

// Cloud Functions 초기화
export const functions = getFunctions(app);

// Firebase Authentication 초기화
export const auth = getAuth(app);

export default app;
